export default __webpack_public_path__ + "static/media/success.3bd5e1db.svg";